/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DateFilterEnum = "all_time" | "last_month" | "last_seven_days" | "last_three_month" | "last_year" | "today" | "%future added value";
export type DashboardHeaderQueryVariables = {
    handle: string;
    includeArchived?: string | null;
    dateFilter: DateFilterEnum;
};
export type DashboardHeaderQueryResponse = {
    readonly dashboardHeaderQuery: {
        readonly summary: ReadonlyArray<string>;
        readonly parentHandle: {
            readonly slug: string;
            readonly name: string;
            readonly image: {
                readonly url: string | null;
                readonly " $fragmentRefs": FragmentRefs<"ItemImage_data">;
            } | null;
        } | null;
        readonly selectedHandle: {
            readonly slug: string;
            readonly title: string | null;
            readonly image: {
                readonly url: string | null;
                readonly " $fragmentRefs": FragmentRefs<"ItemImage_data">;
            } | null;
            readonly badges: ReadonlyArray<{
                readonly " $fragmentRefs": FragmentRefs<"Badge_data">;
            }> | null;
            readonly lines: ReadonlyArray<{
                readonly " $fragmentRefs": FragmentRefs<"SemanticLine_data">;
            }> | null;
        } | null;
        readonly availableHandles: ReadonlyArray<{
            readonly slug: string;
            readonly title: string | null;
        }> | null;
    } | null;
};
export type DashboardHeaderQuery = {
    readonly response: DashboardHeaderQueryResponse;
    readonly variables: DashboardHeaderQueryVariables;
};



/*
query DashboardHeaderQuery(
  $handle: String!
  $includeArchived: String
  $dateFilter: DateFilterEnum!
) {
  dashboardHeaderQuery(handle: $handle, includeArchived: $includeArchived, dateFilter: $dateFilter) {
    summary
    parentHandle {
      slug
      name
      image {
        url
        ...ItemImage_data
      }
    }
    selectedHandle {
      slug
      title
      image {
        url
        ...ItemImage_data
      }
      badges {
        ...Badge_data
      }
      lines {
        ...SemanticLine_data
      }
    }
    availableHandles {
      slug
      title
    }
  }
}

fragment Badge_data on Badge {
  type
}

fragment ItemImage_data on Image {
  url
  alt
  highlight
  shape
  overlay
  overlayIcon
}

fragment SemanticLine_data on SemanticLine {
  parts {
    key
    ...SemanticString_data
  }
}

fragment SemanticString_data on SemanticString {
  text
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dateFilter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "handle"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeArchived"
},
v3 = [
  {
    "kind": "Variable",
    "name": "dateFilter",
    "variableName": "dateFilter"
  },
  {
    "kind": "Variable",
    "name": "handle",
    "variableName": "handle"
  },
  {
    "kind": "Variable",
    "name": "includeArchived",
    "variableName": "includeArchived"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "summary",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ItemImage_data"
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Handle",
  "kind": "LinkedField",
  "name": "availableHandles",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "highlight",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shape",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayIcon",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardHeaderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "DashboardHeader",
        "kind": "LinkedField",
        "name": "dashboardHeaderQuery",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Handle",
            "kind": "LinkedField",
            "name": "parentHandle",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Handle",
            "kind": "LinkedField",
            "name": "selectedHandle",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v9/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Badge",
                "kind": "LinkedField",
                "name": "badges",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "Badge_data"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SemanticLine",
                "kind": "LinkedField",
                "name": "lines",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SemanticLine_data"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "DashboardHeaderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "DashboardHeader",
        "kind": "LinkedField",
        "name": "dashboardHeaderQuery",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Handle",
            "kind": "LinkedField",
            "name": "parentHandle",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Handle",
            "kind": "LinkedField",
            "name": "selectedHandle",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v9/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Badge",
                "kind": "LinkedField",
                "name": "badges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SemanticLine",
                "kind": "LinkedField",
                "name": "lines",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SemanticString",
                    "kind": "LinkedField",
                    "name": "parts",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "key",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "text",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d296cf733396881a7ce5cc2fde80ae0f",
    "id": null,
    "metadata": {},
    "name": "DashboardHeaderQuery",
    "operationKind": "query",
    "text": "query DashboardHeaderQuery(\n  $handle: String!\n  $includeArchived: String\n  $dateFilter: DateFilterEnum!\n) {\n  dashboardHeaderQuery(handle: $handle, includeArchived: $includeArchived, dateFilter: $dateFilter) {\n    summary\n    parentHandle {\n      slug\n      name\n      image {\n        url\n        ...ItemImage_data\n      }\n    }\n    selectedHandle {\n      slug\n      title\n      image {\n        url\n        ...ItemImage_data\n      }\n      badges {\n        ...Badge_data\n      }\n      lines {\n        ...SemanticLine_data\n      }\n    }\n    availableHandles {\n      slug\n      title\n    }\n  }\n}\n\nfragment Badge_data on Badge {\n  type\n}\n\nfragment ItemImage_data on Image {\n  url\n  alt\n  highlight\n  shape\n  overlay\n  overlayIcon\n}\n\nfragment SemanticLine_data on SemanticLine {\n  parts {\n    key\n    ...SemanticString_data\n  }\n}\n\nfragment SemanticString_data on SemanticString {\n  text\n}\n"
  }
};
})();
(node as any).hash = 'f8c4c3251d6881088f7fff19d6020889';
export default node;
